import { useQuery } from 'react-query';

import { handleRefreshToken } from 'utils/refreshToken';
import { API_URL, HEADER_ACCEPT_HR } from 'utils/apiConstants';
import { FetchError } from 'utils/FetchError';
import { GetDefaultPermissionsData, GetPermissionsParams } from 'interfaces/hooks/permissionsHooksInterfaces';

export const useGetDefaultPermissions = ({ isLoggedIn, onError }: GetPermissionsParams): GetDefaultPermissionsData => {
  const { data: defaultPermissions } = useQuery(
    ['default_permissions', isLoggedIn],
    async () => {
      await handleRefreshToken();

      const token = localStorage.getItem('token');

      const res = await fetch(`${API_URL}/company_roles/default_permissions_by_role/`, {
        method: 'GET',
        headers: {
          Accept: `${HEADER_ACCEPT_HR}`,
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        return res.json();
      }
      throw new FetchError(res);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      enabled: isLoggedIn,
      onError,
      select: (res) => res?.data
    }
  );

  return { defaultPermissions };
};
